module.exports = __webpack_public_path__ + "img/18_f.31aa3e70.jpg";